import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';
import {  useSelector } from 'react-redux';
import {toTitleCase} from "utils/common"

export default function useSalaryFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        department, departmentLoading,
        reportTo, reportToLoading,
        nationality, nationalityLoading,
        position, positionLoading,
        division, divisionLoading,
        
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },
    {
        key: "applied_at_after",
        label: "Applied after",
        value: searchParams.get("applied_at_after") || ""
    },
    {
        key: "applied_at_before",
        label: "Applied before",
        value: searchParams.get("applied_at_before") || ""
    },
    {
        key: "gender",
        label: toTitleCase(searchParams.get("gender") || ""),
        value: searchParams.get("gender") || ""
    },

    {
        key: "nationality",
        label: "",
        value: searchParams.get("nationality") || ""
    },
    {
        key: "residency_status",
        label: "",
        value: searchParams.get("residency_status") || ""
    },
    {
        key: "status",
        label: "",
        value: searchParams.get("status") || ""
    },
  ]);

  useEffect(()=>{

    if(!departmentLoading && !reportToLoading && !nationalityLoading && !positionLoading && !divisionLoading ){
        let gender = searchParams.get("gender") || ""

        let selectedReportTo = [...reportTo].find(item=>item.user_id == searchParams.get("report_to") || "")
        let selectedDepartment = [...department].find(item=>item.id == searchParams.get("department") || "")
        // let selectedNationality = [...nationality].find(item=>item.id == searchParams.get("nationality") || "")
        let selectedNationality = [...nationality].filter(item=> (searchParams.get("nationality")||[]).includes(item.id))
        let selectedPosition = [...position].find(item=>item.id == searchParams.get("position") || "")
        let selectedDivision = [...division].find(item=>item.id == searchParams.get("division") || "")
        let status = searchParams.get("status") || ""
        let residencyStatus = searchParams.get("residency_status") || ""

        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            {
                key: "applied_at_after",
                label: "Applied after",
                value: searchParams.get("applied_at_after") || ""
            },
            {
                key: "applied_at_before",
                label: "Joined before",
                value: searchParams.get("applied_at_before") || ""
            },
            {
                key: "gender",
                label: toTitleCase(gender),
                value: gender || ""
            },
           
            // {
            //     key: "nationality",
            //     label: selectedNationality?.name,
            //     value: searchParams.get("nationality") || ""
            // },
           
            {
                key: "status",
                label: toTitleCase(status),
                value: status
            },
            {
                key: "residence_status",
                label: toTitleCase(residencyStatus),
                value: residencyStatus
            }
          ]
          let nationalities = nationality.filter(item => selectedNationality.includes(item.id)).map(item => {
            return { value: item.id,
            label: item.name}
        })
        _filters.push(
            {
                key: "nationality",
                label: selectedNationality?.name,
                value: nationalities
            },
        )
        
          setFilters(_filters)
    }

 
  },[
    department,
    reportTo,
    nationality,
    position,
    division
  ])

  const handleFilterChange =  (data, key, make_call=false) => {
    console.log( "AAAA")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    if(Array.isArray(data)){
        // selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data

    }else{
        selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data?.value || ""
    }
    // selectedFilter['label'] = data?.label || ""
    // selectedFilter['value'] = data?.value || ""
    setFilters(_filters)
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }


    
  };
  const handleInputChange = debounce((data, key, make_call=false) => {
    console.log( "FFFF")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }, 1000)

  const handleDateChange = (data, key, make_call=false) => {

    
    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange
  };
}
